import { gql } from '@apollo/client';

export const GET_USAGE_RECORDS = gql`
    query GetPortalUsageRecords($startDate: LocalDate, $endDate: LocalDate, $timezone: String, $page: Int, $size: Int) {
        portalUsageRecords(startDate: $startDate, endDate: $endDate, timezone: $timezone, page: $page, size: $size) {
            content {
                id
                usageTime
                orderNumber
                trackingNumber
                usageAmount
                currency
                isRefunded
            }
            totalElements
            totalPages
            page
            size
        }
    }
`;
